<template>
  <v-container fill-height>
    <div>Bye-bye...</div>
  </v-container>
</template>

<script>
    export default {
        components: {},
        data() {
            return {}
        },
        created() {
            this.logout()
        },
        methods: {
            logout() {
                this.$store.dispatch('auth/logout')
                    .then(() => {
                        this.$store.dispatch('snackbar/info', 'You have Successfully Logged Out. Goodbye!')
                        this.$router.push('/login').catch(() => {})
                    })
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
